"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GraphErrorContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 14px;\n  font-weight: 100;\n  padding: 48px;\n  height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GraphErrorContainer = _styledComponents["default"].div(_templateObject(), function (_ref) {
  var height = _ref.height;
  return height || 'auto';
});

exports.GraphErrorContainer = GraphErrorContainer;

var GraphError = function GraphError(props) {
  return _react["default"].createElement(GraphErrorContainer, null, props.noData && _react["default"].createElement("div", null, "Not enough data points."), props.noUsers && _react["default"].createElement("div", null, "No users added."), props.noContent && _react["default"].createElement("div", null, "Please embed the unit using our javascript tag integration to see this metric."), props.fetchError && _react["default"].createElement("div", null, "Dang. It seems like we're having trouble loading this!"), props.isIframe && _react["default"].createElement("div", null, "Data unavailable. Please implement a JavaScript Tag to see these metrics."), props.reload && _react["default"].createElement("div", null, _react["default"].createElement("div", null, "Give it another go with this conveniently placed button:"), props.reloadBtn));
};

var _default = GraphError;
exports["default"] = _default;

//# sourceMappingURL=GraphError.jsx.map